import { render, staticRenderFns } from "./cropper.vue?vue&type=template&id=64c49a7d&scoped=true"
import script from "./cropper.vue?vue&type=script&lang=js"
export * from "./cropper.vue?vue&type=script&lang=js"
import style0 from "./cropper.vue?vue&type=style&index=0&id=64c49a7d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c49a7d",
  null
  
)

export default component.exports